module.exports = __webpack_public_path__ + "static/media/07_Mascotte_pollution.ebf6dfe1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/07_Mascotte_pollution.svg
// module id = 763
// module chunks = 0